export default {
    Form: {
        Required: 'Este campo es obligatorio',
        Invalid: 'Lo siento, pero este campo no es válido',
    },
};
